import { render } from "./Outlet_Counters.vue?vue&type=template&id=063b2f1a"
import script from "./Outlet_Counters.vue?vue&type=script&lang=js"
export * from "./Outlet_Counters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__